import Vue from 'vue';
import axios from 'axios';

export async function FetchLearnSkillList({ commit }, parentId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent/${parentId}/learn_skills/`,
  })
    .then((response) => {
      commit('setLearnSkillList', { data: response.data });
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function FetchPlanSkillList({ commit }, parentId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent/${parentId}/get_plan_skills/`,
  })
    .then((response) => {
      commit('setPlanSkillList', { data: response.data });
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function FetchGoalsSkillList({ commit }, parentId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent/${parentId}/get_goals_skills/`,
  })
    .then((response) => {
      commit('setGoalsSkillList', { data: response.data });
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function FetchRateSkillList({ commit }, parentId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent/${parentId}/rate_skills/`,
  })
    .then((response) => {
      commit('setRateSkillList', { data: response.data });
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function FetchSkillName({ commit }, skillId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent_skill/${skillId}/`,
  })
    .then((response) => {
      console.log('name');
      commit('setSkillName', { data: response.data });
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function updateLearnSkillState({ commit }, data) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'POST',
    url: `/parent/${data.parent}/complete_learn/`,
    data: {
      parent: data.parent,
      skill: data.skill,
      learn_completed: data.learn_completed,
    },
  })
    .then((response) => {
      commit('setLearnSkillState', response.data);
    })
    .catch((error) => {
      console.log(error);
      commit('error', error);
    });
}

export async function FetchSkillDescription({ commit }, skillId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent_skill/${skillId}/long_description/`,
  })
    .then((response) => {
      commit('setSkillDescription', { data: response.data });
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function FetchPlanQuestionList({ commit }, skillId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent_skill/${skillId}/plan_questions/`,
  })
    .then((response) => {
      console.log('Fetch');
      commit('setPlanQuestionList', { data: response.data });
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function createSkillPlan({ commit }, data) {
  commit('cleanErrors');
  try {
    const { parent, answers: selectedAnswers } = data;
    const answers = selectedAnswers.filter((a) => a.answer);
    const response = await axios.post(`/parent/${parent}/post_plan_answers/`, { answers });
    commit('setSkillPlan', response.data);
    await FetchGoalsSkillList({ commit }, parent);
  } catch (error) {
    commit('error', error);
    throw error;
  }
}

export async function FetchPlanAnswers({ commit }, data) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent/${data.parent}/get_plan_answers_for_skill/?skill=${data.skill}`,
  })
    .then((response) => {
      commit('setPlanAnswers', { data: response.data });
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function FetchRateQuestionList({ commit }, skillId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent_skill/${skillId}/rate_questions/`,
  })
    .then((response) => {
      console.log('Fetch');
      commit('setRateQuestionList', { data: response.data });
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function updateRateSkillState({ commit }, data) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'POST',
    url: `/parent/${data.parent}/rate_completed/`,
    data: {
      parent: data.parent,
      skill: data.skill,
      rate_completed: data.completed,
    },
  })
    .then((response) => {
      commit('setRateSkillState', response.data);
    })
    .catch((error) => {
      console.log(error);
      commit('error', error);
    });
}

export async function FetchPracticeQuestionList({ commit }, skillId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent_skill/${skillId}/goals_questions/`,
  })
    .then((response) => {
      console.log('Fetch');
      commit('setPracticeQuestionList', { data: response.data });
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function FetchRelatedPlanAnswers({ commit }, data) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'POST',
    url: `/parent/${data.parent}/get_plan_answers_for_goal_question/`,
    data: {
      questions: data.questions,
    },
  })
    .then((response) => {
      commit('setRelatedPlanAnswers', response.data);
    })
    .catch((error) => {
      console.log(error.message);
      commit('error', error);
    });
}

export async function FetchQuestionsToSkip({ commit }, goalId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/goals/${goalId}/get_questions_to_skip/`,
  })
    .then((response) => {
      console.log('Fetch');
      commit('setQuestionsToSkip', { data: response.data });
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function createSkillPractice({ commit }, data) {
  try {
    const { parent, answers } = data;
    const { data: response } = await axios.post(`/parent/${parent}/set_goal_response_item/`, {
      ...answers,
    });
    commit('setSkillPractice', response);
    return `${response['points']}`;
  } catch (error) {
    commit('error', error);
    throw new Error('[Error]: Error when trying create a skill practice (┬┬﹏┬┬)');
  }
}

export async function FetchPracticeAnswers({ commit }, data) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/parent/${data.parent}/get_goals_answers_for_skill/?skill=${data.skill}`,
  })
    .then((response) => {
      console.log('Fetch');
      commit('setPracticeAnswers', { data: response.data });
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function deleteGoalByskillId({ commit }, { parentId, skillId }) {
  try {
    await axios({
      url:`/parent/${parentId}/delete_goal_skill/`,
      method: 'DELETE',
      data: { skill_id: skillId },
    });
    commit('removeSkillFromSkillList', skillId);
  } catch (error) {
    console.log(error);
    throw {
      message: '[Error]: Sorry, we had problems deleting the record, try again later',
      error,
    };
  }
}
